import React, { useRef } from 'react';
import SpeechItem from './SpeechItem';
import '../styles/components/TranscriptPanel.css';
import { SpeechText as ApiSpeechText } from '../types/api';

interface Speaker {
  id: number;
  name: string;
}

interface TranscriptMoment {
  id: number;
  name: string;
}

interface TranscriptData {
  transcript: {
    speech_texts: ApiSpeechText[];
  };
}

interface TranscriptPanelProps {
  transcriptData: TranscriptData;
  activeSegmentId: string | null;
  highlightText: (text: string, speechId: string) => string | (string | React.ReactElement)[];
  onTranscriptClick: (speechId: string) => void;
  onTranscriptMouseEnter: (speechId: string) => void;
  onTranscriptScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
}

const TranscriptPanel: React.FC<TranscriptPanelProps> = ({
  transcriptData,
  activeSegmentId,
  highlightText,
  onTranscriptClick,
  onTranscriptMouseEnter,
  onTranscriptScroll
}) => {
  const transcriptContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="transcript-container">
      <div 
        className="transcript-content" 
        ref={transcriptContainerRef} 
        onScroll={onTranscriptScroll}
      >
        {transcriptData.transcript.speech_texts.map((speech, index) => {
          const speechId = (speech.id || `speech-${speech.start_ms}`).toString();
          const isActive = activeSegmentId === speechId;
          const speaker = {
            id: Number(speech.speaker_id),
            name: speech.speaker_name,
          };
          
          return (
            <SpeechItem
              key={index}
              id={speechId}
              startMs={speech.start_ms}
              endMs={speech.end_ms}
              speech={highlightText(speech.speech, speechId)}
              speaker={speaker}
              moments={speech.transcript_mmts || []}
              isActive={isActive}
              transcriptId={speech.transcript_id || 0}
              remark={speech.remark || ''}
              reviewer={speech.reviewer || ''}
              onClick={onTranscriptClick}
              onMouseEnter={onTranscriptMouseEnter}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TranscriptPanel; 